import { render } from "./IntegrationOrdersListPage.vue?vue&type=template&id=2861818d"
import script from "./IntegrationOrdersListPage.vue?vue&type=script&lang=js"
export * from "./IntegrationOrdersListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__